import type { MobileDeviceModel } from "./MobileDeviceModel";
import type {
  InitiatePairingRequest,
  MobileDevice,
  MobilePairingInitiation,
} from "./MobileDevice.typed";

export class MobileDeviceAdapter {
  constructor(private model: MobileDeviceModel) {}

  async initiatePairing(payload?: InitiatePairingRequest): Promise<MobilePairingInitiation> {
    return this.model.initiatePairing(payload);
  }

  async restartPairing(deviceId: number): Promise<MobilePairingInitiation> {
    return this.model.restartPairing(deviceId);
  }

  async listDevices(): Promise<MobileDevice[]> {
    return this.model.listDevices();
  }

  async deleteDevice(id: number): Promise<void> {
    return this.model.deleteDevice(id);
  }
}
